import { useEffect } from 'react'
import { useAuthStore } from '../stores/authStore'
import { useOnlineStatus } from '../hooks/useOnlineStatus'
import { useOutboxStore } from '../stores/outboxStore'

export default function OutboxFlusher() {
  const isOnline = useOnlineStatus()
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const flush = useOutboxStore((s) => s.flush)
  const count = useOutboxStore((s) => s.pendingCount())

  useEffect(() => {
    if (!isOnline || !isAuthenticated) return
    if (count === 0) return

    void flush()
  }, [count, flush, isAuthenticated, isOnline])

  useEffect(() => {
    if (!isOnline || !isAuthenticated) return

    const id = window.setInterval(() => {
      void flush()
    }, 15000)

    return () => window.clearInterval(id)
  }, [flush, isAuthenticated, isOnline])

  return null
}

